// ag-grid-enterprise v19.1.4
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var cell = {
    getTemplate: function (c) {
        var mergeAcross = c.mergeAcross, styleId = c.styleId, data = c.data;
        var properties = {};
        if (mergeAcross) {
            properties['MergeAcross'] = mergeAcross;
        }
        if (styleId) {
            properties['StyleID'] = styleId;
        }
        return {
            name: "Cell",
            properties: {
                prefixedAttributes: [{
                        prefix: "ss:",
                        map: properties
                    }]
            },
            children: [{
                    name: "Data",
                    properties: {
                        prefixedAttributes: [{
                                prefix: "ss:",
                                map: {
                                    Type: data.type
                                }
                            }]
                    },
                    textNode: data.value
                }]
        };
    }
};
exports.default = cell;



//////////////////
// WEBPACK FOOTER
// ./~/_ag-grid-enterprise@19.1.4@ag-grid-enterprise/dist/lib/exporter/files/xml/cell.js
// module id = 783
// module chunks = 5